// source: witbooking/backoffice/bundle/v1/bundle_api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var validate_validate_pb = require('../../../../validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
var witbooking_backoffice_common_common_pb = require('../../../../witbooking/backoffice/common/common_pb.js');
goog.object.extend(proto, witbooking_backoffice_common_common_pb);
goog.exportSymbol('proto.witbooking.backoffice.bundle.v2.Bundle', null, global);
goog.exportSymbol('proto.witbooking.backoffice.bundle.v2.BundleTranslation', null, global);
goog.exportSymbol('proto.witbooking.backoffice.bundle.v2.BundleType', null, global);
goog.exportSymbol('proto.witbooking.backoffice.bundle.v2.CreateBundleRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.bundle.v2.CreateBundleResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.bundle.v2.DeleteBundleRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.bundle.v2.DeleteBundleResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.bundle.v2.GetBundleRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.bundle.v2.GetBundleResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.bundle.v2.GetBundlesRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.bundle.v2.GetBundlesResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.bundle.v2.Multimedia', null, global);
goog.exportSymbol('proto.witbooking.backoffice.bundle.v2.ReorderBundleRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.bundle.v2.ReorderBundleResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.bundle.v2.RestrictionValue', null, global);
goog.exportSymbol('proto.witbooking.backoffice.bundle.v2.RestrictionValue.ValueCase', null, global);
goog.exportSymbol('proto.witbooking.backoffice.bundle.v2.RestrictionValueConstant', null, global);
goog.exportSymbol('proto.witbooking.backoffice.bundle.v2.RestrictionValueConstant.ValueCase', null, global);
goog.exportSymbol('proto.witbooking.backoffice.bundle.v2.RestrictionValueOwn', null, global);
goog.exportSymbol('proto.witbooking.backoffice.bundle.v2.Restrictions', null, global);
goog.exportSymbol('proto.witbooking.backoffice.bundle.v2.UpdateBundleRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.bundle.v2.UpdateBundleResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.bundle.v2.ReorderBundleRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.bundle.v2.ReorderBundleRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.bundle.v2.ReorderBundleRequest.displayName = 'proto.witbooking.backoffice.bundle.v2.ReorderBundleRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.bundle.v2.ReorderBundleResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.bundle.v2.ReorderBundleResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.bundle.v2.ReorderBundleResponse.displayName = 'proto.witbooking.backoffice.bundle.v2.ReorderBundleResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.bundle.v2.CreateBundleRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.bundle.v2.CreateBundleRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.bundle.v2.CreateBundleRequest.displayName = 'proto.witbooking.backoffice.bundle.v2.CreateBundleRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.bundle.v2.CreateBundleResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.bundle.v2.CreateBundleResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.bundle.v2.CreateBundleResponse.displayName = 'proto.witbooking.backoffice.bundle.v2.CreateBundleResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.bundle.v2.UpdateBundleRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.bundle.v2.UpdateBundleRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.bundle.v2.UpdateBundleRequest.displayName = 'proto.witbooking.backoffice.bundle.v2.UpdateBundleRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.bundle.v2.UpdateBundleResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.bundle.v2.UpdateBundleResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.bundle.v2.UpdateBundleResponse.displayName = 'proto.witbooking.backoffice.bundle.v2.UpdateBundleResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.bundle.v2.DeleteBundleRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.bundle.v2.DeleteBundleRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.bundle.v2.DeleteBundleRequest.displayName = 'proto.witbooking.backoffice.bundle.v2.DeleteBundleRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.bundle.v2.DeleteBundleResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.bundle.v2.DeleteBundleResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.bundle.v2.DeleteBundleResponse.displayName = 'proto.witbooking.backoffice.bundle.v2.DeleteBundleResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.bundle.v2.GetBundleRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.bundle.v2.GetBundleRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.bundle.v2.GetBundleRequest.displayName = 'proto.witbooking.backoffice.bundle.v2.GetBundleRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.bundle.v2.GetBundleResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.bundle.v2.GetBundleResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.bundle.v2.GetBundleResponse.displayName = 'proto.witbooking.backoffice.bundle.v2.GetBundleResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.bundle.v2.GetBundlesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.bundle.v2.GetBundlesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.bundle.v2.GetBundlesRequest.displayName = 'proto.witbooking.backoffice.bundle.v2.GetBundlesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.bundle.v2.GetBundlesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.bundle.v2.GetBundlesResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.bundle.v2.GetBundlesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.bundle.v2.GetBundlesResponse.displayName = 'proto.witbooking.backoffice.bundle.v2.GetBundlesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.bundle.v2.BundleTranslation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.bundle.v2.BundleTranslation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.bundle.v2.BundleTranslation.displayName = 'proto.witbooking.backoffice.bundle.v2.BundleTranslation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.bundle.v2.Multimedia = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.bundle.v2.Multimedia.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.bundle.v2.Multimedia, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.bundle.v2.Multimedia.displayName = 'proto.witbooking.backoffice.bundle.v2.Multimedia';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.bundle.v2.Bundle = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.bundle.v2.Bundle.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.bundle.v2.Bundle, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.bundle.v2.Bundle.displayName = 'proto.witbooking.backoffice.bundle.v2.Bundle';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.bundle.v2.Restrictions = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.bundle.v2.Restrictions, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.bundle.v2.Restrictions.displayName = 'proto.witbooking.backoffice.bundle.v2.Restrictions';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.bundle.v2.RestrictionValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.witbooking.backoffice.bundle.v2.RestrictionValue.oneofGroups_);
};
goog.inherits(proto.witbooking.backoffice.bundle.v2.RestrictionValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.bundle.v2.RestrictionValue.displayName = 'proto.witbooking.backoffice.bundle.v2.RestrictionValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.bundle.v2.RestrictionValueConstant = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.witbooking.backoffice.bundle.v2.RestrictionValueConstant.oneofGroups_);
};
goog.inherits(proto.witbooking.backoffice.bundle.v2.RestrictionValueConstant, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.bundle.v2.RestrictionValueConstant.displayName = 'proto.witbooking.backoffice.bundle.v2.RestrictionValueConstant';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.bundle.v2.RestrictionValueOwn = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.bundle.v2.RestrictionValueOwn, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.bundle.v2.RestrictionValueOwn.displayName = 'proto.witbooking.backoffice.bundle.v2.RestrictionValueOwn';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.bundle.v2.ReorderBundleRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.bundle.v2.ReorderBundleRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.bundle.v2.ReorderBundleRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.bundle.v2.ReorderBundleRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    bundleId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    afterId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.bundle.v2.ReorderBundleRequest}
 */
proto.witbooking.backoffice.bundle.v2.ReorderBundleRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.bundle.v2.ReorderBundleRequest;
  return proto.witbooking.backoffice.bundle.v2.ReorderBundleRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.bundle.v2.ReorderBundleRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.bundle.v2.ReorderBundleRequest}
 */
proto.witbooking.backoffice.bundle.v2.ReorderBundleRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBundleId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAfterId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.bundle.v2.ReorderBundleRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.bundle.v2.ReorderBundleRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.bundle.v2.ReorderBundleRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.bundle.v2.ReorderBundleRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBundleId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAfterId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string bundle_id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.bundle.v2.ReorderBundleRequest.prototype.getBundleId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.bundle.v2.ReorderBundleRequest} returns this
 */
proto.witbooking.backoffice.bundle.v2.ReorderBundleRequest.prototype.setBundleId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string after_id = 2;
 * @return {string}
 */
proto.witbooking.backoffice.bundle.v2.ReorderBundleRequest.prototype.getAfterId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.bundle.v2.ReorderBundleRequest} returns this
 */
proto.witbooking.backoffice.bundle.v2.ReorderBundleRequest.prototype.setAfterId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.bundle.v2.ReorderBundleResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.bundle.v2.ReorderBundleResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.bundle.v2.ReorderBundleResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.bundle.v2.ReorderBundleResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.bundle.v2.ReorderBundleResponse}
 */
proto.witbooking.backoffice.bundle.v2.ReorderBundleResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.bundle.v2.ReorderBundleResponse;
  return proto.witbooking.backoffice.bundle.v2.ReorderBundleResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.bundle.v2.ReorderBundleResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.bundle.v2.ReorderBundleResponse}
 */
proto.witbooking.backoffice.bundle.v2.ReorderBundleResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.bundle.v2.ReorderBundleResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.bundle.v2.ReorderBundleResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.bundle.v2.ReorderBundleResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.bundle.v2.ReorderBundleResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.bundle.v2.CreateBundleRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.bundle.v2.CreateBundleRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.bundle.v2.CreateBundleRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.bundle.v2.CreateBundleRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    bundle: (f = msg.getBundle()) && proto.witbooking.backoffice.bundle.v2.Bundle.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.bundle.v2.CreateBundleRequest}
 */
proto.witbooking.backoffice.bundle.v2.CreateBundleRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.bundle.v2.CreateBundleRequest;
  return proto.witbooking.backoffice.bundle.v2.CreateBundleRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.bundle.v2.CreateBundleRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.bundle.v2.CreateBundleRequest}
 */
proto.witbooking.backoffice.bundle.v2.CreateBundleRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.bundle.v2.Bundle;
      reader.readMessage(value,proto.witbooking.backoffice.bundle.v2.Bundle.deserializeBinaryFromReader);
      msg.setBundle(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.bundle.v2.CreateBundleRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.bundle.v2.CreateBundleRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.bundle.v2.CreateBundleRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.bundle.v2.CreateBundleRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBundle();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.bundle.v2.Bundle.serializeBinaryToWriter
    );
  }
};


/**
 * optional Bundle bundle = 1;
 * @return {?proto.witbooking.backoffice.bundle.v2.Bundle}
 */
proto.witbooking.backoffice.bundle.v2.CreateBundleRequest.prototype.getBundle = function() {
  return /** @type{?proto.witbooking.backoffice.bundle.v2.Bundle} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.bundle.v2.Bundle, 1));
};


/**
 * @param {?proto.witbooking.backoffice.bundle.v2.Bundle|undefined} value
 * @return {!proto.witbooking.backoffice.bundle.v2.CreateBundleRequest} returns this
*/
proto.witbooking.backoffice.bundle.v2.CreateBundleRequest.prototype.setBundle = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.bundle.v2.CreateBundleRequest} returns this
 */
proto.witbooking.backoffice.bundle.v2.CreateBundleRequest.prototype.clearBundle = function() {
  return this.setBundle(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.bundle.v2.CreateBundleRequest.prototype.hasBundle = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.bundle.v2.CreateBundleResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.bundle.v2.CreateBundleResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.bundle.v2.CreateBundleResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.bundle.v2.CreateBundleResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    bundle: (f = msg.getBundle()) && proto.witbooking.backoffice.bundle.v2.Bundle.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.bundle.v2.CreateBundleResponse}
 */
proto.witbooking.backoffice.bundle.v2.CreateBundleResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.bundle.v2.CreateBundleResponse;
  return proto.witbooking.backoffice.bundle.v2.CreateBundleResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.bundle.v2.CreateBundleResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.bundle.v2.CreateBundleResponse}
 */
proto.witbooking.backoffice.bundle.v2.CreateBundleResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.bundle.v2.Bundle;
      reader.readMessage(value,proto.witbooking.backoffice.bundle.v2.Bundle.deserializeBinaryFromReader);
      msg.setBundle(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.bundle.v2.CreateBundleResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.bundle.v2.CreateBundleResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.bundle.v2.CreateBundleResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.bundle.v2.CreateBundleResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBundle();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.bundle.v2.Bundle.serializeBinaryToWriter
    );
  }
};


/**
 * optional Bundle bundle = 1;
 * @return {?proto.witbooking.backoffice.bundle.v2.Bundle}
 */
proto.witbooking.backoffice.bundle.v2.CreateBundleResponse.prototype.getBundle = function() {
  return /** @type{?proto.witbooking.backoffice.bundle.v2.Bundle} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.bundle.v2.Bundle, 1));
};


/**
 * @param {?proto.witbooking.backoffice.bundle.v2.Bundle|undefined} value
 * @return {!proto.witbooking.backoffice.bundle.v2.CreateBundleResponse} returns this
*/
proto.witbooking.backoffice.bundle.v2.CreateBundleResponse.prototype.setBundle = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.bundle.v2.CreateBundleResponse} returns this
 */
proto.witbooking.backoffice.bundle.v2.CreateBundleResponse.prototype.clearBundle = function() {
  return this.setBundle(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.bundle.v2.CreateBundleResponse.prototype.hasBundle = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.bundle.v2.UpdateBundleRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.bundle.v2.UpdateBundleRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.bundle.v2.UpdateBundleRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.bundle.v2.UpdateBundleRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    bundle: (f = msg.getBundle()) && proto.witbooking.backoffice.bundle.v2.Bundle.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.bundle.v2.UpdateBundleRequest}
 */
proto.witbooking.backoffice.bundle.v2.UpdateBundleRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.bundle.v2.UpdateBundleRequest;
  return proto.witbooking.backoffice.bundle.v2.UpdateBundleRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.bundle.v2.UpdateBundleRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.bundle.v2.UpdateBundleRequest}
 */
proto.witbooking.backoffice.bundle.v2.UpdateBundleRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.bundle.v2.Bundle;
      reader.readMessage(value,proto.witbooking.backoffice.bundle.v2.Bundle.deserializeBinaryFromReader);
      msg.setBundle(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.bundle.v2.UpdateBundleRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.bundle.v2.UpdateBundleRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.bundle.v2.UpdateBundleRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.bundle.v2.UpdateBundleRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBundle();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.bundle.v2.Bundle.serializeBinaryToWriter
    );
  }
};


/**
 * optional Bundle bundle = 1;
 * @return {?proto.witbooking.backoffice.bundle.v2.Bundle}
 */
proto.witbooking.backoffice.bundle.v2.UpdateBundleRequest.prototype.getBundle = function() {
  return /** @type{?proto.witbooking.backoffice.bundle.v2.Bundle} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.bundle.v2.Bundle, 1));
};


/**
 * @param {?proto.witbooking.backoffice.bundle.v2.Bundle|undefined} value
 * @return {!proto.witbooking.backoffice.bundle.v2.UpdateBundleRequest} returns this
*/
proto.witbooking.backoffice.bundle.v2.UpdateBundleRequest.prototype.setBundle = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.bundle.v2.UpdateBundleRequest} returns this
 */
proto.witbooking.backoffice.bundle.v2.UpdateBundleRequest.prototype.clearBundle = function() {
  return this.setBundle(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.bundle.v2.UpdateBundleRequest.prototype.hasBundle = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.bundle.v2.UpdateBundleResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.bundle.v2.UpdateBundleResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.bundle.v2.UpdateBundleResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.bundle.v2.UpdateBundleResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    bundle: (f = msg.getBundle()) && proto.witbooking.backoffice.bundle.v2.Bundle.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.bundle.v2.UpdateBundleResponse}
 */
proto.witbooking.backoffice.bundle.v2.UpdateBundleResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.bundle.v2.UpdateBundleResponse;
  return proto.witbooking.backoffice.bundle.v2.UpdateBundleResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.bundle.v2.UpdateBundleResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.bundle.v2.UpdateBundleResponse}
 */
proto.witbooking.backoffice.bundle.v2.UpdateBundleResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.bundle.v2.Bundle;
      reader.readMessage(value,proto.witbooking.backoffice.bundle.v2.Bundle.deserializeBinaryFromReader);
      msg.setBundle(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.bundle.v2.UpdateBundleResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.bundle.v2.UpdateBundleResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.bundle.v2.UpdateBundleResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.bundle.v2.UpdateBundleResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBundle();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.bundle.v2.Bundle.serializeBinaryToWriter
    );
  }
};


/**
 * optional Bundle bundle = 1;
 * @return {?proto.witbooking.backoffice.bundle.v2.Bundle}
 */
proto.witbooking.backoffice.bundle.v2.UpdateBundleResponse.prototype.getBundle = function() {
  return /** @type{?proto.witbooking.backoffice.bundle.v2.Bundle} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.bundle.v2.Bundle, 1));
};


/**
 * @param {?proto.witbooking.backoffice.bundle.v2.Bundle|undefined} value
 * @return {!proto.witbooking.backoffice.bundle.v2.UpdateBundleResponse} returns this
*/
proto.witbooking.backoffice.bundle.v2.UpdateBundleResponse.prototype.setBundle = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.bundle.v2.UpdateBundleResponse} returns this
 */
proto.witbooking.backoffice.bundle.v2.UpdateBundleResponse.prototype.clearBundle = function() {
  return this.setBundle(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.bundle.v2.UpdateBundleResponse.prototype.hasBundle = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.bundle.v2.DeleteBundleRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.bundle.v2.DeleteBundleRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.bundle.v2.DeleteBundleRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.bundle.v2.DeleteBundleRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    bundleId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.bundle.v2.DeleteBundleRequest}
 */
proto.witbooking.backoffice.bundle.v2.DeleteBundleRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.bundle.v2.DeleteBundleRequest;
  return proto.witbooking.backoffice.bundle.v2.DeleteBundleRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.bundle.v2.DeleteBundleRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.bundle.v2.DeleteBundleRequest}
 */
proto.witbooking.backoffice.bundle.v2.DeleteBundleRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBundleId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.bundle.v2.DeleteBundleRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.bundle.v2.DeleteBundleRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.bundle.v2.DeleteBundleRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.bundle.v2.DeleteBundleRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBundleId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string bundle_id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.bundle.v2.DeleteBundleRequest.prototype.getBundleId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.bundle.v2.DeleteBundleRequest} returns this
 */
proto.witbooking.backoffice.bundle.v2.DeleteBundleRequest.prototype.setBundleId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.bundle.v2.DeleteBundleResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.bundle.v2.DeleteBundleResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.bundle.v2.DeleteBundleResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.bundle.v2.DeleteBundleResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.bundle.v2.DeleteBundleResponse}
 */
proto.witbooking.backoffice.bundle.v2.DeleteBundleResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.bundle.v2.DeleteBundleResponse;
  return proto.witbooking.backoffice.bundle.v2.DeleteBundleResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.bundle.v2.DeleteBundleResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.bundle.v2.DeleteBundleResponse}
 */
proto.witbooking.backoffice.bundle.v2.DeleteBundleResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.bundle.v2.DeleteBundleResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.bundle.v2.DeleteBundleResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.bundle.v2.DeleteBundleResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.bundle.v2.DeleteBundleResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.bundle.v2.GetBundleRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.bundle.v2.GetBundleRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.bundle.v2.GetBundleRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.bundle.v2.GetBundleRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    bundleId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.bundle.v2.GetBundleRequest}
 */
proto.witbooking.backoffice.bundle.v2.GetBundleRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.bundle.v2.GetBundleRequest;
  return proto.witbooking.backoffice.bundle.v2.GetBundleRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.bundle.v2.GetBundleRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.bundle.v2.GetBundleRequest}
 */
proto.witbooking.backoffice.bundle.v2.GetBundleRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBundleId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.bundle.v2.GetBundleRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.bundle.v2.GetBundleRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.bundle.v2.GetBundleRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.bundle.v2.GetBundleRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBundleId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string bundle_id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.bundle.v2.GetBundleRequest.prototype.getBundleId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.bundle.v2.GetBundleRequest} returns this
 */
proto.witbooking.backoffice.bundle.v2.GetBundleRequest.prototype.setBundleId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.bundle.v2.GetBundleResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.bundle.v2.GetBundleResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.bundle.v2.GetBundleResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.bundle.v2.GetBundleResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    bundle: (f = msg.getBundle()) && proto.witbooking.backoffice.bundle.v2.Bundle.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.bundle.v2.GetBundleResponse}
 */
proto.witbooking.backoffice.bundle.v2.GetBundleResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.bundle.v2.GetBundleResponse;
  return proto.witbooking.backoffice.bundle.v2.GetBundleResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.bundle.v2.GetBundleResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.bundle.v2.GetBundleResponse}
 */
proto.witbooking.backoffice.bundle.v2.GetBundleResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.bundle.v2.Bundle;
      reader.readMessage(value,proto.witbooking.backoffice.bundle.v2.Bundle.deserializeBinaryFromReader);
      msg.setBundle(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.bundle.v2.GetBundleResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.bundle.v2.GetBundleResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.bundle.v2.GetBundleResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.bundle.v2.GetBundleResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBundle();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.bundle.v2.Bundle.serializeBinaryToWriter
    );
  }
};


/**
 * optional Bundle bundle = 1;
 * @return {?proto.witbooking.backoffice.bundle.v2.Bundle}
 */
proto.witbooking.backoffice.bundle.v2.GetBundleResponse.prototype.getBundle = function() {
  return /** @type{?proto.witbooking.backoffice.bundle.v2.Bundle} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.bundle.v2.Bundle, 1));
};


/**
 * @param {?proto.witbooking.backoffice.bundle.v2.Bundle|undefined} value
 * @return {!proto.witbooking.backoffice.bundle.v2.GetBundleResponse} returns this
*/
proto.witbooking.backoffice.bundle.v2.GetBundleResponse.prototype.setBundle = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.bundle.v2.GetBundleResponse} returns this
 */
proto.witbooking.backoffice.bundle.v2.GetBundleResponse.prototype.clearBundle = function() {
  return this.setBundle(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.bundle.v2.GetBundleResponse.prototype.hasBundle = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.bundle.v2.GetBundlesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.bundle.v2.GetBundlesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.bundle.v2.GetBundlesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.bundle.v2.GetBundlesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.bundle.v2.GetBundlesRequest}
 */
proto.witbooking.backoffice.bundle.v2.GetBundlesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.bundle.v2.GetBundlesRequest;
  return proto.witbooking.backoffice.bundle.v2.GetBundlesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.bundle.v2.GetBundlesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.bundle.v2.GetBundlesRequest}
 */
proto.witbooking.backoffice.bundle.v2.GetBundlesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.witbooking.backoffice.bundle.v2.BundleType} */ (reader.readEnum());
      msg.setType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.bundle.v2.GetBundlesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.bundle.v2.GetBundlesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.bundle.v2.GetBundlesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.bundle.v2.GetBundlesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional BundleType type = 1;
 * @return {!proto.witbooking.backoffice.bundle.v2.BundleType}
 */
proto.witbooking.backoffice.bundle.v2.GetBundlesRequest.prototype.getType = function() {
  return /** @type {!proto.witbooking.backoffice.bundle.v2.BundleType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.witbooking.backoffice.bundle.v2.BundleType} value
 * @return {!proto.witbooking.backoffice.bundle.v2.GetBundlesRequest} returns this
 */
proto.witbooking.backoffice.bundle.v2.GetBundlesRequest.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.bundle.v2.GetBundlesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.bundle.v2.GetBundlesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.bundle.v2.GetBundlesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.bundle.v2.GetBundlesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.bundle.v2.GetBundlesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    bundleList: jspb.Message.toObjectList(msg.getBundleList(),
    proto.witbooking.backoffice.bundle.v2.Bundle.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.bundle.v2.GetBundlesResponse}
 */
proto.witbooking.backoffice.bundle.v2.GetBundlesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.bundle.v2.GetBundlesResponse;
  return proto.witbooking.backoffice.bundle.v2.GetBundlesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.bundle.v2.GetBundlesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.bundle.v2.GetBundlesResponse}
 */
proto.witbooking.backoffice.bundle.v2.GetBundlesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.bundle.v2.Bundle;
      reader.readMessage(value,proto.witbooking.backoffice.bundle.v2.Bundle.deserializeBinaryFromReader);
      msg.addBundle(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.bundle.v2.GetBundlesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.bundle.v2.GetBundlesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.bundle.v2.GetBundlesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.bundle.v2.GetBundlesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBundleList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.backoffice.bundle.v2.Bundle.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Bundle bundle = 1;
 * @return {!Array<!proto.witbooking.backoffice.bundle.v2.Bundle>}
 */
proto.witbooking.backoffice.bundle.v2.GetBundlesResponse.prototype.getBundleList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.bundle.v2.Bundle>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.bundle.v2.Bundle, 1));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.bundle.v2.Bundle>} value
 * @return {!proto.witbooking.backoffice.bundle.v2.GetBundlesResponse} returns this
*/
proto.witbooking.backoffice.bundle.v2.GetBundlesResponse.prototype.setBundleList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.backoffice.bundle.v2.Bundle=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.bundle.v2.Bundle}
 */
proto.witbooking.backoffice.bundle.v2.GetBundlesResponse.prototype.addBundle = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.backoffice.bundle.v2.Bundle, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.bundle.v2.GetBundlesResponse} returns this
 */
proto.witbooking.backoffice.bundle.v2.GetBundlesResponse.prototype.clearBundleList = function() {
  return this.setBundleList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.bundle.v2.BundleTranslation.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.bundle.v2.BundleTranslation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.bundle.v2.BundleTranslation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.bundle.v2.BundleTranslation.toObject = function(includeInstance, msg) {
  var f, obj = {
    locale: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    description: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.bundle.v2.BundleTranslation}
 */
proto.witbooking.backoffice.bundle.v2.BundleTranslation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.bundle.v2.BundleTranslation;
  return proto.witbooking.backoffice.bundle.v2.BundleTranslation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.bundle.v2.BundleTranslation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.bundle.v2.BundleTranslation}
 */
proto.witbooking.backoffice.bundle.v2.BundleTranslation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocale(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.bundle.v2.BundleTranslation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.bundle.v2.BundleTranslation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.bundle.v2.BundleTranslation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.bundle.v2.BundleTranslation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLocale();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string locale = 1;
 * @return {string}
 */
proto.witbooking.backoffice.bundle.v2.BundleTranslation.prototype.getLocale = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.bundle.v2.BundleTranslation} returns this
 */
proto.witbooking.backoffice.bundle.v2.BundleTranslation.prototype.setLocale = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.witbooking.backoffice.bundle.v2.BundleTranslation.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.bundle.v2.BundleTranslation} returns this
 */
proto.witbooking.backoffice.bundle.v2.BundleTranslation.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.witbooking.backoffice.bundle.v2.BundleTranslation.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.bundle.v2.BundleTranslation} returns this
 */
proto.witbooking.backoffice.bundle.v2.BundleTranslation.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.bundle.v2.Multimedia.repeatedFields_ = [4,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.bundle.v2.Multimedia.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.bundle.v2.Multimedia.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.bundle.v2.Multimedia} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.bundle.v2.Multimedia.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    filename: jspb.Message.getFieldWithDefault(msg, 2, ""),
    url: jspb.Message.getFieldWithDefault(msg, 3, ""),
    translationsList: jspb.Message.toObjectList(msg.getTranslationsList(),
    witbooking_backoffice_common_common_pb.MultimediaTranslation.toObject, includeInstance),
    labelsList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
    caption: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.bundle.v2.Multimedia}
 */
proto.witbooking.backoffice.bundle.v2.Multimedia.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.bundle.v2.Multimedia;
  return proto.witbooking.backoffice.bundle.v2.Multimedia.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.bundle.v2.Multimedia} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.bundle.v2.Multimedia}
 */
proto.witbooking.backoffice.bundle.v2.Multimedia.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilename(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 4:
      var value = new witbooking_backoffice_common_common_pb.MultimediaTranslation;
      reader.readMessage(value,witbooking_backoffice_common_common_pb.MultimediaTranslation.deserializeBinaryFromReader);
      msg.addTranslations(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addLabels(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCaption(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.bundle.v2.Multimedia.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.bundle.v2.Multimedia.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.bundle.v2.Multimedia} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.bundle.v2.Multimedia.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFilename();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTranslationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      witbooking_backoffice_common_common_pb.MultimediaTranslation.serializeBinaryToWriter
    );
  }
  f = message.getLabelsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
  f = message.getCaption();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.bundle.v2.Multimedia.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.bundle.v2.Multimedia} returns this
 */
proto.witbooking.backoffice.bundle.v2.Multimedia.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string filename = 2;
 * @return {string}
 */
proto.witbooking.backoffice.bundle.v2.Multimedia.prototype.getFilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.bundle.v2.Multimedia} returns this
 */
proto.witbooking.backoffice.bundle.v2.Multimedia.prototype.setFilename = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string url = 3;
 * @return {string}
 */
proto.witbooking.backoffice.bundle.v2.Multimedia.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.bundle.v2.Multimedia} returns this
 */
proto.witbooking.backoffice.bundle.v2.Multimedia.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated witbooking.backoffice.common.MultimediaTranslation translations = 4;
 * @return {!Array<!proto.witbooking.backoffice.common.MultimediaTranslation>}
 */
proto.witbooking.backoffice.bundle.v2.Multimedia.prototype.getTranslationsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.common.MultimediaTranslation>} */ (
    jspb.Message.getRepeatedWrapperField(this, witbooking_backoffice_common_common_pb.MultimediaTranslation, 4));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.common.MultimediaTranslation>} value
 * @return {!proto.witbooking.backoffice.bundle.v2.Multimedia} returns this
*/
proto.witbooking.backoffice.bundle.v2.Multimedia.prototype.setTranslationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.witbooking.backoffice.common.MultimediaTranslation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.common.MultimediaTranslation}
 */
proto.witbooking.backoffice.bundle.v2.Multimedia.prototype.addTranslations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.witbooking.backoffice.common.MultimediaTranslation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.bundle.v2.Multimedia} returns this
 */
proto.witbooking.backoffice.bundle.v2.Multimedia.prototype.clearTranslationsList = function() {
  return this.setTranslationsList([]);
};


/**
 * repeated string labels = 5;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.bundle.v2.Multimedia.prototype.getLabelsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.bundle.v2.Multimedia} returns this
 */
proto.witbooking.backoffice.bundle.v2.Multimedia.prototype.setLabelsList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.bundle.v2.Multimedia} returns this
 */
proto.witbooking.backoffice.bundle.v2.Multimedia.prototype.addLabels = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.bundle.v2.Multimedia} returns this
 */
proto.witbooking.backoffice.bundle.v2.Multimedia.prototype.clearLabelsList = function() {
  return this.setLabelsList([]);
};


/**
 * optional string caption = 7;
 * @return {string}
 */
proto.witbooking.backoffice.bundle.v2.Multimedia.prototype.getCaption = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.bundle.v2.Multimedia} returns this
 */
proto.witbooking.backoffice.bundle.v2.Multimedia.prototype.setCaption = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.bundle.v2.Bundle.repeatedFields_ = [4,5,7,8,9,18,19,20];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.bundle.v2.Bundle.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.bundle.v2.Bundle} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.bundle.v2.Bundle.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    ticker: jspb.Message.getFieldWithDefault(msg, 2, ""),
    inventoryLinesList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
    multimediaList: jspb.Message.toObjectList(msg.getMultimediaList(),
    proto.witbooking.backoffice.bundle.v2.Multimedia.toObject, includeInstance),
    active: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    extrasList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
    promotionsList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f,
    travelWindowsList: jspb.Message.toObjectList(msg.getTravelWindowsList(),
    witbooking_backoffice_common_common_pb.TravelWindow.toObject, includeInstance),
    minStay: jspb.Message.getFieldWithDefault(msg, 10, 0),
    maxStay: jspb.Message.getFieldWithDefault(msg, 11, 0),
    minRelease: jspb.Message.getFieldWithDefault(msg, 12, 0),
    maxRelease: jspb.Message.getFieldWithDefault(msg, 13, 0),
    bundlePriceType: jspb.Message.getFieldWithDefault(msg, 14, 0),
    bundlePrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 15, 0.0),
    visible: jspb.Message.getBooleanFieldWithDefault(msg, 16, false),
    bundleRestrictionType: jspb.Message.getFieldWithDefault(msg, 17, 0),
    bookingWindowsList: jspb.Message.toObjectList(msg.getBookingWindowsList(),
    witbooking_backoffice_common_common_pb.TravelWindow.toObject, includeInstance),
    translationsList: jspb.Message.toObjectList(msg.getTranslationsList(),
    proto.witbooking.backoffice.bundle.v2.BundleTranslation.toObject, includeInstance),
    codesList: (f = jspb.Message.getRepeatedField(msg, 20)) == null ? undefined : f,
    restrictions: (f = msg.getRestrictions()) && proto.witbooking.backoffice.bundle.v2.Restrictions.toObject(includeInstance, f),
    type: jspb.Message.getFieldWithDefault(msg, 22, 0),
    bookableProductTicker: (f = msg.getBookableProductTicker()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.bundle.v2.Bundle}
 */
proto.witbooking.backoffice.bundle.v2.Bundle.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.bundle.v2.Bundle;
  return proto.witbooking.backoffice.bundle.v2.Bundle.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.bundle.v2.Bundle} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.bundle.v2.Bundle}
 */
proto.witbooking.backoffice.bundle.v2.Bundle.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addInventoryLines(value);
      break;
    case 5:
      var value = new proto.witbooking.backoffice.bundle.v2.Multimedia;
      reader.readMessage(value,proto.witbooking.backoffice.bundle.v2.Multimedia.deserializeBinaryFromReader);
      msg.addMultimedia(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActive(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.addExtras(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.addPromotions(value);
      break;
    case 9:
      var value = new witbooking_backoffice_common_common_pb.TravelWindow;
      reader.readMessage(value,witbooking_backoffice_common_common_pb.TravelWindow.deserializeBinaryFromReader);
      msg.addTravelWindows(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMinStay(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxStay(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMinRelease(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxRelease(value);
      break;
    case 14:
      var value = /** @type {!proto.witbooking.backoffice.common.BundlePriceType} */ (reader.readEnum());
      msg.setBundlePriceType(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setBundlePrice(value);
      break;
    case 16:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVisible(value);
      break;
    case 17:
      var value = /** @type {!proto.witbooking.backoffice.common.BundleRestrictionType} */ (reader.readEnum());
      msg.setBundleRestrictionType(value);
      break;
    case 18:
      var value = new witbooking_backoffice_common_common_pb.TravelWindow;
      reader.readMessage(value,witbooking_backoffice_common_common_pb.TravelWindow.deserializeBinaryFromReader);
      msg.addBookingWindows(value);
      break;
    case 19:
      var value = new proto.witbooking.backoffice.bundle.v2.BundleTranslation;
      reader.readMessage(value,proto.witbooking.backoffice.bundle.v2.BundleTranslation.deserializeBinaryFromReader);
      msg.addTranslations(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.addCodes(value);
      break;
    case 21:
      var value = new proto.witbooking.backoffice.bundle.v2.Restrictions;
      reader.readMessage(value,proto.witbooking.backoffice.bundle.v2.Restrictions.deserializeBinaryFromReader);
      msg.setRestrictions(value);
      break;
    case 22:
      var value = /** @type {!proto.witbooking.backoffice.bundle.v2.BundleType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 23:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setBookableProductTicker(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.bundle.v2.Bundle.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.bundle.v2.Bundle} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.bundle.v2.Bundle.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getInventoryLinesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getMultimediaList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.witbooking.backoffice.bundle.v2.Multimedia.serializeBinaryToWriter
    );
  }
  f = message.getActive();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getExtrasList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      7,
      f
    );
  }
  f = message.getPromotionsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      8,
      f
    );
  }
  f = message.getTravelWindowsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      witbooking_backoffice_common_common_pb.TravelWindow.serializeBinaryToWriter
    );
  }
  f = message.getMinStay();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getMaxStay();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getMinRelease();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
  f = message.getMaxRelease();
  if (f !== 0) {
    writer.writeInt32(
      13,
      f
    );
  }
  f = message.getBundlePriceType();
  if (f !== 0.0) {
    writer.writeEnum(
      14,
      f
    );
  }
  f = message.getBundlePrice();
  if (f !== 0.0) {
    writer.writeDouble(
      15,
      f
    );
  }
  f = message.getVisible();
  if (f) {
    writer.writeBool(
      16,
      f
    );
  }
  f = message.getBundleRestrictionType();
  if (f !== 0.0) {
    writer.writeEnum(
      17,
      f
    );
  }
  f = message.getBookingWindowsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      18,
      f,
      witbooking_backoffice_common_common_pb.TravelWindow.serializeBinaryToWriter
    );
  }
  f = message.getTranslationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      19,
      f,
      proto.witbooking.backoffice.bundle.v2.BundleTranslation.serializeBinaryToWriter
    );
  }
  f = message.getCodesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      20,
      f
    );
  }
  f = message.getRestrictions();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      proto.witbooking.backoffice.bundle.v2.Restrictions.serializeBinaryToWriter
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      22,
      f
    );
  }
  f = message.getBookableProductTicker();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.bundle.v2.Bundle} returns this
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ticker = 2;
 * @return {string}
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.bundle.v2.Bundle} returns this
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string inventory_lines = 4;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.getInventoryLinesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.bundle.v2.Bundle} returns this
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.setInventoryLinesList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.bundle.v2.Bundle} returns this
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.addInventoryLines = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.bundle.v2.Bundle} returns this
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.clearInventoryLinesList = function() {
  return this.setInventoryLinesList([]);
};


/**
 * repeated Multimedia multimedia = 5;
 * @return {!Array<!proto.witbooking.backoffice.bundle.v2.Multimedia>}
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.getMultimediaList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.bundle.v2.Multimedia>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.bundle.v2.Multimedia, 5));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.bundle.v2.Multimedia>} value
 * @return {!proto.witbooking.backoffice.bundle.v2.Bundle} returns this
*/
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.setMultimediaList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.witbooking.backoffice.bundle.v2.Multimedia=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.bundle.v2.Multimedia}
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.addMultimedia = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.witbooking.backoffice.bundle.v2.Multimedia, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.bundle.v2.Bundle} returns this
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.clearMultimediaList = function() {
  return this.setMultimediaList([]);
};


/**
 * optional bool active = 6;
 * @return {boolean}
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.getActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.bundle.v2.Bundle} returns this
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.setActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * repeated string extras = 7;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.getExtrasList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.bundle.v2.Bundle} returns this
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.setExtrasList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.bundle.v2.Bundle} returns this
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.addExtras = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.bundle.v2.Bundle} returns this
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.clearExtrasList = function() {
  return this.setExtrasList([]);
};


/**
 * repeated string promotions = 8;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.getPromotionsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 8));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.bundle.v2.Bundle} returns this
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.setPromotionsList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.bundle.v2.Bundle} returns this
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.addPromotions = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.bundle.v2.Bundle} returns this
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.clearPromotionsList = function() {
  return this.setPromotionsList([]);
};


/**
 * repeated witbooking.backoffice.common.TravelWindow travel_windows = 9;
 * @return {!Array<!proto.witbooking.backoffice.common.TravelWindow>}
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.getTravelWindowsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.common.TravelWindow>} */ (
    jspb.Message.getRepeatedWrapperField(this, witbooking_backoffice_common_common_pb.TravelWindow, 9));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.common.TravelWindow>} value
 * @return {!proto.witbooking.backoffice.bundle.v2.Bundle} returns this
*/
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.setTravelWindowsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.witbooking.backoffice.common.TravelWindow=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.common.TravelWindow}
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.addTravelWindows = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.witbooking.backoffice.common.TravelWindow, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.bundle.v2.Bundle} returns this
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.clearTravelWindowsList = function() {
  return this.setTravelWindowsList([]);
};


/**
 * optional int32 min_stay = 10;
 * @return {number}
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.getMinStay = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.bundle.v2.Bundle} returns this
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.setMinStay = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int32 max_stay = 11;
 * @return {number}
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.getMaxStay = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.bundle.v2.Bundle} returns this
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.setMaxStay = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int32 min_release = 12;
 * @return {number}
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.getMinRelease = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.bundle.v2.Bundle} returns this
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.setMinRelease = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int32 max_release = 13;
 * @return {number}
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.getMaxRelease = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.bundle.v2.Bundle} returns this
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.setMaxRelease = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional witbooking.backoffice.common.BundlePriceType bundle_price_type = 14;
 * @return {!proto.witbooking.backoffice.common.BundlePriceType}
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.getBundlePriceType = function() {
  return /** @type {!proto.witbooking.backoffice.common.BundlePriceType} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {!proto.witbooking.backoffice.common.BundlePriceType} value
 * @return {!proto.witbooking.backoffice.bundle.v2.Bundle} returns this
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.setBundlePriceType = function(value) {
  return jspb.Message.setProto3EnumField(this, 14, value);
};


/**
 * optional double bundle_price = 15;
 * @return {number}
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.getBundlePrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 15, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.bundle.v2.Bundle} returns this
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.setBundlePrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 15, value);
};


/**
 * optional bool visible = 16;
 * @return {boolean}
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.getVisible = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 16, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.bundle.v2.Bundle} returns this
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.setVisible = function(value) {
  return jspb.Message.setProto3BooleanField(this, 16, value);
};


/**
 * optional witbooking.backoffice.common.BundleRestrictionType bundle_restriction_type = 17;
 * @return {!proto.witbooking.backoffice.common.BundleRestrictionType}
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.getBundleRestrictionType = function() {
  return /** @type {!proto.witbooking.backoffice.common.BundleRestrictionType} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {!proto.witbooking.backoffice.common.BundleRestrictionType} value
 * @return {!proto.witbooking.backoffice.bundle.v2.Bundle} returns this
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.setBundleRestrictionType = function(value) {
  return jspb.Message.setProto3EnumField(this, 17, value);
};


/**
 * repeated witbooking.backoffice.common.TravelWindow booking_windows = 18;
 * @return {!Array<!proto.witbooking.backoffice.common.TravelWindow>}
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.getBookingWindowsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.common.TravelWindow>} */ (
    jspb.Message.getRepeatedWrapperField(this, witbooking_backoffice_common_common_pb.TravelWindow, 18));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.common.TravelWindow>} value
 * @return {!proto.witbooking.backoffice.bundle.v2.Bundle} returns this
*/
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.setBookingWindowsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 18, value);
};


/**
 * @param {!proto.witbooking.backoffice.common.TravelWindow=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.common.TravelWindow}
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.addBookingWindows = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 18, opt_value, proto.witbooking.backoffice.common.TravelWindow, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.bundle.v2.Bundle} returns this
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.clearBookingWindowsList = function() {
  return this.setBookingWindowsList([]);
};


/**
 * repeated BundleTranslation translations = 19;
 * @return {!Array<!proto.witbooking.backoffice.bundle.v2.BundleTranslation>}
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.getTranslationsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.bundle.v2.BundleTranslation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.bundle.v2.BundleTranslation, 19));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.bundle.v2.BundleTranslation>} value
 * @return {!proto.witbooking.backoffice.bundle.v2.Bundle} returns this
*/
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.setTranslationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 19, value);
};


/**
 * @param {!proto.witbooking.backoffice.bundle.v2.BundleTranslation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.bundle.v2.BundleTranslation}
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.addTranslations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 19, opt_value, proto.witbooking.backoffice.bundle.v2.BundleTranslation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.bundle.v2.Bundle} returns this
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.clearTranslationsList = function() {
  return this.setTranslationsList([]);
};


/**
 * repeated string codes = 20;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.getCodesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 20));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.bundle.v2.Bundle} returns this
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.setCodesList = function(value) {
  return jspb.Message.setField(this, 20, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.bundle.v2.Bundle} returns this
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.addCodes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 20, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.bundle.v2.Bundle} returns this
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.clearCodesList = function() {
  return this.setCodesList([]);
};


/**
 * optional Restrictions restrictions = 21;
 * @return {?proto.witbooking.backoffice.bundle.v2.Restrictions}
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.getRestrictions = function() {
  return /** @type{?proto.witbooking.backoffice.bundle.v2.Restrictions} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.bundle.v2.Restrictions, 21));
};


/**
 * @param {?proto.witbooking.backoffice.bundle.v2.Restrictions|undefined} value
 * @return {!proto.witbooking.backoffice.bundle.v2.Bundle} returns this
*/
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.setRestrictions = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.bundle.v2.Bundle} returns this
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.clearRestrictions = function() {
  return this.setRestrictions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.hasRestrictions = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional BundleType type = 22;
 * @return {!proto.witbooking.backoffice.bundle.v2.BundleType}
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.getType = function() {
  return /** @type {!proto.witbooking.backoffice.bundle.v2.BundleType} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/**
 * @param {!proto.witbooking.backoffice.bundle.v2.BundleType} value
 * @return {!proto.witbooking.backoffice.bundle.v2.Bundle} returns this
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 22, value);
};


/**
 * optional google.protobuf.StringValue bookable_product_ticker = 23;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.getBookableProductTicker = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 23));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.witbooking.backoffice.bundle.v2.Bundle} returns this
*/
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.setBookableProductTicker = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.bundle.v2.Bundle} returns this
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.clearBookableProductTicker = function() {
  return this.setBookableProductTicker(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.bundle.v2.Bundle.prototype.hasBookableProductTicker = function() {
  return jspb.Message.getField(this, 23) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.bundle.v2.Restrictions.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.bundle.v2.Restrictions.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.bundle.v2.Restrictions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.bundle.v2.Restrictions.toObject = function(includeInstance, msg) {
  var f, obj = {
    minStay: (f = msg.getMinStay()) && proto.witbooking.backoffice.bundle.v2.RestrictionValue.toObject(includeInstance, f),
    maxStay: (f = msg.getMaxStay()) && proto.witbooking.backoffice.bundle.v2.RestrictionValue.toObject(includeInstance, f),
    minNotice: (f = msg.getMinNotice()) && proto.witbooking.backoffice.bundle.v2.RestrictionValue.toObject(includeInstance, f),
    maxNotice: (f = msg.getMaxNotice()) && proto.witbooking.backoffice.bundle.v2.RestrictionValue.toObject(includeInstance, f),
    closeToArrival: (f = msg.getCloseToArrival()) && proto.witbooking.backoffice.bundle.v2.RestrictionValue.toObject(includeInstance, f),
    closeToDeparture: (f = msg.getCloseToDeparture()) && proto.witbooking.backoffice.bundle.v2.RestrictionValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.bundle.v2.Restrictions}
 */
proto.witbooking.backoffice.bundle.v2.Restrictions.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.bundle.v2.Restrictions;
  return proto.witbooking.backoffice.bundle.v2.Restrictions.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.bundle.v2.Restrictions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.bundle.v2.Restrictions}
 */
proto.witbooking.backoffice.bundle.v2.Restrictions.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 3:
      var value = new proto.witbooking.backoffice.bundle.v2.RestrictionValue;
      reader.readMessage(value,proto.witbooking.backoffice.bundle.v2.RestrictionValue.deserializeBinaryFromReader);
      msg.setMinStay(value);
      break;
    case 4:
      var value = new proto.witbooking.backoffice.bundle.v2.RestrictionValue;
      reader.readMessage(value,proto.witbooking.backoffice.bundle.v2.RestrictionValue.deserializeBinaryFromReader);
      msg.setMaxStay(value);
      break;
    case 5:
      var value = new proto.witbooking.backoffice.bundle.v2.RestrictionValue;
      reader.readMessage(value,proto.witbooking.backoffice.bundle.v2.RestrictionValue.deserializeBinaryFromReader);
      msg.setMinNotice(value);
      break;
    case 6:
      var value = new proto.witbooking.backoffice.bundle.v2.RestrictionValue;
      reader.readMessage(value,proto.witbooking.backoffice.bundle.v2.RestrictionValue.deserializeBinaryFromReader);
      msg.setMaxNotice(value);
      break;
    case 7:
      var value = new proto.witbooking.backoffice.bundle.v2.RestrictionValue;
      reader.readMessage(value,proto.witbooking.backoffice.bundle.v2.RestrictionValue.deserializeBinaryFromReader);
      msg.setCloseToArrival(value);
      break;
    case 8:
      var value = new proto.witbooking.backoffice.bundle.v2.RestrictionValue;
      reader.readMessage(value,proto.witbooking.backoffice.bundle.v2.RestrictionValue.deserializeBinaryFromReader);
      msg.setCloseToDeparture(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.bundle.v2.Restrictions.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.bundle.v2.Restrictions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.bundle.v2.Restrictions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.bundle.v2.Restrictions.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMinStay();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.witbooking.backoffice.bundle.v2.RestrictionValue.serializeBinaryToWriter
    );
  }
  f = message.getMaxStay();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.witbooking.backoffice.bundle.v2.RestrictionValue.serializeBinaryToWriter
    );
  }
  f = message.getMinNotice();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.witbooking.backoffice.bundle.v2.RestrictionValue.serializeBinaryToWriter
    );
  }
  f = message.getMaxNotice();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.witbooking.backoffice.bundle.v2.RestrictionValue.serializeBinaryToWriter
    );
  }
  f = message.getCloseToArrival();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.witbooking.backoffice.bundle.v2.RestrictionValue.serializeBinaryToWriter
    );
  }
  f = message.getCloseToDeparture();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.witbooking.backoffice.bundle.v2.RestrictionValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional RestrictionValue min_stay = 3;
 * @return {?proto.witbooking.backoffice.bundle.v2.RestrictionValue}
 */
proto.witbooking.backoffice.bundle.v2.Restrictions.prototype.getMinStay = function() {
  return /** @type{?proto.witbooking.backoffice.bundle.v2.RestrictionValue} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.bundle.v2.RestrictionValue, 3));
};


/**
 * @param {?proto.witbooking.backoffice.bundle.v2.RestrictionValue|undefined} value
 * @return {!proto.witbooking.backoffice.bundle.v2.Restrictions} returns this
*/
proto.witbooking.backoffice.bundle.v2.Restrictions.prototype.setMinStay = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.bundle.v2.Restrictions} returns this
 */
proto.witbooking.backoffice.bundle.v2.Restrictions.prototype.clearMinStay = function() {
  return this.setMinStay(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.bundle.v2.Restrictions.prototype.hasMinStay = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional RestrictionValue max_stay = 4;
 * @return {?proto.witbooking.backoffice.bundle.v2.RestrictionValue}
 */
proto.witbooking.backoffice.bundle.v2.Restrictions.prototype.getMaxStay = function() {
  return /** @type{?proto.witbooking.backoffice.bundle.v2.RestrictionValue} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.bundle.v2.RestrictionValue, 4));
};


/**
 * @param {?proto.witbooking.backoffice.bundle.v2.RestrictionValue|undefined} value
 * @return {!proto.witbooking.backoffice.bundle.v2.Restrictions} returns this
*/
proto.witbooking.backoffice.bundle.v2.Restrictions.prototype.setMaxStay = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.bundle.v2.Restrictions} returns this
 */
proto.witbooking.backoffice.bundle.v2.Restrictions.prototype.clearMaxStay = function() {
  return this.setMaxStay(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.bundle.v2.Restrictions.prototype.hasMaxStay = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional RestrictionValue min_notice = 5;
 * @return {?proto.witbooking.backoffice.bundle.v2.RestrictionValue}
 */
proto.witbooking.backoffice.bundle.v2.Restrictions.prototype.getMinNotice = function() {
  return /** @type{?proto.witbooking.backoffice.bundle.v2.RestrictionValue} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.bundle.v2.RestrictionValue, 5));
};


/**
 * @param {?proto.witbooking.backoffice.bundle.v2.RestrictionValue|undefined} value
 * @return {!proto.witbooking.backoffice.bundle.v2.Restrictions} returns this
*/
proto.witbooking.backoffice.bundle.v2.Restrictions.prototype.setMinNotice = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.bundle.v2.Restrictions} returns this
 */
proto.witbooking.backoffice.bundle.v2.Restrictions.prototype.clearMinNotice = function() {
  return this.setMinNotice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.bundle.v2.Restrictions.prototype.hasMinNotice = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional RestrictionValue max_notice = 6;
 * @return {?proto.witbooking.backoffice.bundle.v2.RestrictionValue}
 */
proto.witbooking.backoffice.bundle.v2.Restrictions.prototype.getMaxNotice = function() {
  return /** @type{?proto.witbooking.backoffice.bundle.v2.RestrictionValue} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.bundle.v2.RestrictionValue, 6));
};


/**
 * @param {?proto.witbooking.backoffice.bundle.v2.RestrictionValue|undefined} value
 * @return {!proto.witbooking.backoffice.bundle.v2.Restrictions} returns this
*/
proto.witbooking.backoffice.bundle.v2.Restrictions.prototype.setMaxNotice = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.bundle.v2.Restrictions} returns this
 */
proto.witbooking.backoffice.bundle.v2.Restrictions.prototype.clearMaxNotice = function() {
  return this.setMaxNotice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.bundle.v2.Restrictions.prototype.hasMaxNotice = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional RestrictionValue close_to_arrival = 7;
 * @return {?proto.witbooking.backoffice.bundle.v2.RestrictionValue}
 */
proto.witbooking.backoffice.bundle.v2.Restrictions.prototype.getCloseToArrival = function() {
  return /** @type{?proto.witbooking.backoffice.bundle.v2.RestrictionValue} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.bundle.v2.RestrictionValue, 7));
};


/**
 * @param {?proto.witbooking.backoffice.bundle.v2.RestrictionValue|undefined} value
 * @return {!proto.witbooking.backoffice.bundle.v2.Restrictions} returns this
*/
proto.witbooking.backoffice.bundle.v2.Restrictions.prototype.setCloseToArrival = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.bundle.v2.Restrictions} returns this
 */
proto.witbooking.backoffice.bundle.v2.Restrictions.prototype.clearCloseToArrival = function() {
  return this.setCloseToArrival(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.bundle.v2.Restrictions.prototype.hasCloseToArrival = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional RestrictionValue close_to_departure = 8;
 * @return {?proto.witbooking.backoffice.bundle.v2.RestrictionValue}
 */
proto.witbooking.backoffice.bundle.v2.Restrictions.prototype.getCloseToDeparture = function() {
  return /** @type{?proto.witbooking.backoffice.bundle.v2.RestrictionValue} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.bundle.v2.RestrictionValue, 8));
};


/**
 * @param {?proto.witbooking.backoffice.bundle.v2.RestrictionValue|undefined} value
 * @return {!proto.witbooking.backoffice.bundle.v2.Restrictions} returns this
*/
proto.witbooking.backoffice.bundle.v2.Restrictions.prototype.setCloseToDeparture = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.bundle.v2.Restrictions} returns this
 */
proto.witbooking.backoffice.bundle.v2.Restrictions.prototype.clearCloseToDeparture = function() {
  return this.setCloseToDeparture(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.bundle.v2.Restrictions.prototype.hasCloseToDeparture = function() {
  return jspb.Message.getField(this, 8) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.witbooking.backoffice.bundle.v2.RestrictionValue.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.witbooking.backoffice.bundle.v2.RestrictionValue.ValueCase = {
  VALUE_NOT_SET: 0,
  CONSTANT: 1,
  OWN: 2
};

/**
 * @return {proto.witbooking.backoffice.bundle.v2.RestrictionValue.ValueCase}
 */
proto.witbooking.backoffice.bundle.v2.RestrictionValue.prototype.getValueCase = function() {
  return /** @type {proto.witbooking.backoffice.bundle.v2.RestrictionValue.ValueCase} */(jspb.Message.computeOneofCase(this, proto.witbooking.backoffice.bundle.v2.RestrictionValue.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.bundle.v2.RestrictionValue.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.bundle.v2.RestrictionValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.bundle.v2.RestrictionValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.bundle.v2.RestrictionValue.toObject = function(includeInstance, msg) {
  var f, obj = {
    constant: (f = msg.getConstant()) && proto.witbooking.backoffice.bundle.v2.RestrictionValueConstant.toObject(includeInstance, f),
    own: (f = msg.getOwn()) && proto.witbooking.backoffice.bundle.v2.RestrictionValueOwn.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.bundle.v2.RestrictionValue}
 */
proto.witbooking.backoffice.bundle.v2.RestrictionValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.bundle.v2.RestrictionValue;
  return proto.witbooking.backoffice.bundle.v2.RestrictionValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.bundle.v2.RestrictionValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.bundle.v2.RestrictionValue}
 */
proto.witbooking.backoffice.bundle.v2.RestrictionValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.bundle.v2.RestrictionValueConstant;
      reader.readMessage(value,proto.witbooking.backoffice.bundle.v2.RestrictionValueConstant.deserializeBinaryFromReader);
      msg.setConstant(value);
      break;
    case 2:
      var value = new proto.witbooking.backoffice.bundle.v2.RestrictionValueOwn;
      reader.readMessage(value,proto.witbooking.backoffice.bundle.v2.RestrictionValueOwn.deserializeBinaryFromReader);
      msg.setOwn(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.bundle.v2.RestrictionValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.bundle.v2.RestrictionValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.bundle.v2.RestrictionValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.bundle.v2.RestrictionValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConstant();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.bundle.v2.RestrictionValueConstant.serializeBinaryToWriter
    );
  }
  f = message.getOwn();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.witbooking.backoffice.bundle.v2.RestrictionValueOwn.serializeBinaryToWriter
    );
  }
};


/**
 * optional RestrictionValueConstant constant = 1;
 * @return {?proto.witbooking.backoffice.bundle.v2.RestrictionValueConstant}
 */
proto.witbooking.backoffice.bundle.v2.RestrictionValue.prototype.getConstant = function() {
  return /** @type{?proto.witbooking.backoffice.bundle.v2.RestrictionValueConstant} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.bundle.v2.RestrictionValueConstant, 1));
};


/**
 * @param {?proto.witbooking.backoffice.bundle.v2.RestrictionValueConstant|undefined} value
 * @return {!proto.witbooking.backoffice.bundle.v2.RestrictionValue} returns this
*/
proto.witbooking.backoffice.bundle.v2.RestrictionValue.prototype.setConstant = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.witbooking.backoffice.bundle.v2.RestrictionValue.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.bundle.v2.RestrictionValue} returns this
 */
proto.witbooking.backoffice.bundle.v2.RestrictionValue.prototype.clearConstant = function() {
  return this.setConstant(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.bundle.v2.RestrictionValue.prototype.hasConstant = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional RestrictionValueOwn own = 2;
 * @return {?proto.witbooking.backoffice.bundle.v2.RestrictionValueOwn}
 */
proto.witbooking.backoffice.bundle.v2.RestrictionValue.prototype.getOwn = function() {
  return /** @type{?proto.witbooking.backoffice.bundle.v2.RestrictionValueOwn} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.bundle.v2.RestrictionValueOwn, 2));
};


/**
 * @param {?proto.witbooking.backoffice.bundle.v2.RestrictionValueOwn|undefined} value
 * @return {!proto.witbooking.backoffice.bundle.v2.RestrictionValue} returns this
*/
proto.witbooking.backoffice.bundle.v2.RestrictionValue.prototype.setOwn = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.witbooking.backoffice.bundle.v2.RestrictionValue.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.bundle.v2.RestrictionValue} returns this
 */
proto.witbooking.backoffice.bundle.v2.RestrictionValue.prototype.clearOwn = function() {
  return this.setOwn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.bundle.v2.RestrictionValue.prototype.hasOwn = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.witbooking.backoffice.bundle.v2.RestrictionValueConstant.oneofGroups_ = [[1]];

/**
 * @enum {number}
 */
proto.witbooking.backoffice.bundle.v2.RestrictionValueConstant.ValueCase = {
  VALUE_NOT_SET: 0,
  INT_VALUE: 1
};

/**
 * @return {proto.witbooking.backoffice.bundle.v2.RestrictionValueConstant.ValueCase}
 */
proto.witbooking.backoffice.bundle.v2.RestrictionValueConstant.prototype.getValueCase = function() {
  return /** @type {proto.witbooking.backoffice.bundle.v2.RestrictionValueConstant.ValueCase} */(jspb.Message.computeOneofCase(this, proto.witbooking.backoffice.bundle.v2.RestrictionValueConstant.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.bundle.v2.RestrictionValueConstant.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.bundle.v2.RestrictionValueConstant.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.bundle.v2.RestrictionValueConstant} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.bundle.v2.RestrictionValueConstant.toObject = function(includeInstance, msg) {
  var f, obj = {
    intValue: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.bundle.v2.RestrictionValueConstant}
 */
proto.witbooking.backoffice.bundle.v2.RestrictionValueConstant.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.bundle.v2.RestrictionValueConstant;
  return proto.witbooking.backoffice.bundle.v2.RestrictionValueConstant.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.bundle.v2.RestrictionValueConstant} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.bundle.v2.RestrictionValueConstant}
 */
proto.witbooking.backoffice.bundle.v2.RestrictionValueConstant.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIntValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.bundle.v2.RestrictionValueConstant.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.bundle.v2.RestrictionValueConstant.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.bundle.v2.RestrictionValueConstant} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.bundle.v2.RestrictionValueConstant.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 int_value = 1;
 * @return {number}
 */
proto.witbooking.backoffice.bundle.v2.RestrictionValueConstant.prototype.getIntValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.bundle.v2.RestrictionValueConstant} returns this
 */
proto.witbooking.backoffice.bundle.v2.RestrictionValueConstant.prototype.setIntValue = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.witbooking.backoffice.bundle.v2.RestrictionValueConstant.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.witbooking.backoffice.bundle.v2.RestrictionValueConstant} returns this
 */
proto.witbooking.backoffice.bundle.v2.RestrictionValueConstant.prototype.clearIntValue = function() {
  return jspb.Message.setOneofField(this, 1, proto.witbooking.backoffice.bundle.v2.RestrictionValueConstant.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.bundle.v2.RestrictionValueConstant.prototype.hasIntValue = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.bundle.v2.RestrictionValueOwn.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.bundle.v2.RestrictionValueOwn.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.bundle.v2.RestrictionValueOwn} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.bundle.v2.RestrictionValueOwn.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.bundle.v2.RestrictionValueOwn}
 */
proto.witbooking.backoffice.bundle.v2.RestrictionValueOwn.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.bundle.v2.RestrictionValueOwn;
  return proto.witbooking.backoffice.bundle.v2.RestrictionValueOwn.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.bundle.v2.RestrictionValueOwn} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.bundle.v2.RestrictionValueOwn}
 */
proto.witbooking.backoffice.bundle.v2.RestrictionValueOwn.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.bundle.v2.RestrictionValueOwn.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.bundle.v2.RestrictionValueOwn.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.bundle.v2.RestrictionValueOwn} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.bundle.v2.RestrictionValueOwn.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.witbooking.backoffice.bundle.v2.BundleType = {
  ENGINE: 0,
  STORE: 1
};

goog.object.extend(exports, proto.witbooking.backoffice.bundle.v2);
